import React, { useState } from "react";

import Navbar from "../components/Navbar";
import Sidebar from "../components/Sidebar";

function Inspection() {

  const [inspections, setInspections] = useState([]);

  const [form, setForm] = useState({
    supervisor: "",
    plot: "",
    water: "",
    plant: "",
    fence: "",
    soil: "",
    remarks: "",
    priority: "Low"
  });

  const handleChange = (e) => {

    setForm({
      ...form,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {

    e.preventDefault();

    setInspections([
      ...inspections,
      form
    ]);

    setForm({
      supervisor: "",
      plot: "",
      water: "",
      plant: "",
      fence: "",
      soil: "",
      remarks: "",
      priority: "Low"
    });
  };

  return (

    <div>

      <Navbar />

      <Sidebar />

      <div className="main-content">

        <h1>Inspections</h1>

        <form onSubmit={handleSubmit}>

          <input
            type="text"
            name="supervisor"
            placeholder="Supervisor Name"
            value={form.supervisor}
            onChange={handleChange}
          />

          <input
            type="text"
            name="plot"
            placeholder="Plot Number"
            value={form.plot}
            onChange={handleChange}
          />

          <input
            type="text"
            name="water"
            placeholder="Water Status"
            value={form.water}
            onChange={handleChange}
          />

          <input
            type="text"
            name="plant"
            placeholder="Plant Status"
            value={form.plant}
            onChange={handleChange}
          />

          <input
            type="text"
            name="fence"
            placeholder="Fence Status"
            value={form.fence}
            onChange={handleChange}
          />

          <input
            type="text"
            name="soil"
            placeholder="Soil Condition"
            value={form.soil}
            onChange={handleChange}
          />

          <input
            type="text"
            name="remarks"
            placeholder="Remarks"
            value={form.remarks}
            onChange={handleChange}
          />

          <select
            name="priority"
            value={form.priority}
            onChange={handleChange}
          >
            <option>Low</option>
            <option>Medium</option>
            <option>High</option>
            <option>Critical</option>
          </select>

          <button type="submit">
            Add Inspection
          </button>

        </form>

      </div>

    </div>
  );
}

export default Inspection;